import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2a6a1a50"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "card"
};
var _hoisted_2 = {
  class: "card-header"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "归档", -1);
});

var _hoisted_4 = {
  class: "card-body archive-list"
};
var _hoisted_5 = {
  class: "archive-date"
};
var _hoisted_6 = {
  class: "archive-count"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");

  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("span", null, [_createVNode(_component_font_awesome_icon, {
    icon: ['fas', 'box-archive'],
    class: "header-icon"
  })]), _hoisted_3]), _createVNode(_component_router_link, {
    to: "/archive/",
    class: "header-more-link",
    title: "查看更多"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'angle-right'],
        class: "header-more-icon"
      })];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.archiveCounts, function (archive) {
    return _openBlock(), _createBlock(_component_router_link, {
      key: archive.date,
      to: "/archive/".concat(archive.date),
      class: "archive-item"
    }, {
      default: _withCtx(function () {
        return [_createElementVNode("span", _hoisted_5, _toDisplayString(archive.date.split("/")[0]) + " 年 " + _toDisplayString(archive.date.split("/")[1]) + " 月 ", 1), _createElementVNode("span", _hoisted_6, _toDisplayString(archive.count), 1)];
      }),
      _: 2
    }, 1032, ["to"]);
  }), 128))])]);
}